import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const deactivateActivatePatient = async ({ type, patientIds }) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(
    `${__API_URL__}/api/auth/staff/deactivate_activate_patient/${type}/`,
    { patient_ids: patientIds },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useDeactivateActivatePatientMutation = () => {
  return useMutation({
    mutationFn: deactivateActivatePatient,
  });
};

export default useDeactivateActivatePatientMutation;
